var helpers = {
    windowHeight: $(window).height(),
    init: function () {
        $(window).on(
            'resize',
            theme.helpers.throttle(function () {
                theme.helpers.windowHeight = $(window).height();
                $(window).trigger('scroll');
            }, 250)
        );
    },
    throttle: function (fn, wait) {
        var time = Date.now();
        return function () {
            if (time + wait - Date.now() < 0) {
                fn();
                time = Date.now();
            }
        };
    },
    debounce: function (fn, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) fn.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) fn.apply(context, args);
        };
    },
};

export { helpers };
